import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Spinner from 'react-bootstrap/Spinner';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import roleType from '../../constants/roles';
import { alpha } from '@material-ui/core/styles';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withFirebase } from '../Firebase';
import { withAuthorization } from '../Session';

class Storetag extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            alert: 0,
            alertMessage: '',
            flag: false,
            columns: [
                { title: 'Store Tag', field: 'Tag' },
                { title: 'Assigned', field: 'Assigned', editable: 'never' },
                { title: 'Assigned On', field: 'Date', editable: 'never' }
            ],
            data: []
        };
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
    }

    async loadData() {
        await RestServices.getAvaliableStoreTags(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    if (this._isMounted) {
                        this.setState({ alert: 1, alertMessage: data.error });
                    }
                } else {
                    
                    if (this._isMounted) {
                        this.setState({ data: data, flag: true, alert: 0 });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async addUpdateRow(oldData, newData) {
        await RestServices.updateRoyalty(
            localStorage.getItem('FirebaseToken'),
            oldData.storeGroup,
            newData
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState((prevState) => {
                    const data = [...prevState.data];
                    data[data.indexOf(oldData)] = newData;
                    return { ...prevState, data };
                });
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    async addRow(newData) {
        newData.Assigned = false;

        let dataBody = {
            Tag: newData.Tag,
            Assigned: false
        };

        
        await RestServices.addAvaliableStoreTag(
            localStorage.getItem('FirebaseToken'),
            dataBody
        )
            .then((response) => response.json())
            .then((responseData) => {
                if (responseData.success) {
                    this.setState((prevState) => {
                        const data = [...prevState.data];
                        data.push(newData);
                        return { ...prevState, data };
                    });
                } else {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: 'Oops! something went wrong...'
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });
    }

    render() {
        return (
            <Container>
                <Row>
                    <KeyboardBackspaceRoundedIcon
                        style={{ cursor: 'pointer', color: 'blue' }}
                        onClick={this.props.flagHandler}
                    />
                    <h4 style={{ marginLeft: '1rem' }}>Avaliable Store Tags</h4>
                </Row>
                <div>
                    <hr />
                </div>

                {this.state.alert === 1 && (
                    <Row>
                        <Col>
                            <Alert variant="danger">
                                {this.state.alertMessage}
                            </Alert>
                        </Col>
                    </Row>
                )}

                {this.state.flag === false && <Spinner animation="border" />}
                {this.state.flag === true && (
                    <MaterialTable
                        components={{ Pagination: PatchedPagination }}
                        title="Store Tags"
                        columns={this.state.columns}
                        data={this.state.data}
                        options={{
                            filtering: true,
                            actionsColumnIndex: -1,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                        editable={
                            this.props.role == 'Admin'
                                ? {
                                      onRowAdd: (newData) =>
                                          this.addRow(newData)
                                  }
                                : {}
                        }
                    />
                )}
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(Storetag);
